import {
  GET_HISTORY_LIST_ACCOUNTANT_SUCCESS,
  GET_HISTORY_LIST_ACCOUNTANT_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  activitylogAccountant: [], // this will hold only the logs array
  error: null,
};

const activitylogReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_HISTORY_LIST_ACCOUNTANT_SUCCESS:
      console.log("[Reducer Triggered] Type:", action.type, "Payload:", action.payload);
      return {
        ...state,
        activitylogAccountant: action.payload?.logs || [], // safely extract logs
        error: null,
      };

    case GET_HISTORY_LIST_ACCOUNTANT_FAIL:
      console.error("[Reducer Triggered] Error:", action.payload);
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default activitylogReducer;
